module.exports = __webpack_public_path__ + "static/j-dark-eb3f48052c3b9e8b7be3baa7afb94bdf.svg";